//using the old pagination style
angular.module(NgAppName).directive('crPaginationV2', [function() {
	return {
    retrict: 'E',
		scope: true,
		templateUrl: 'crPaginationV2/crPaginationV2.html',
		link: function(scope, element, attrs) {
			scope.removeNextPrevLabels = attrs.removeNextPrevLabels;

			var pagesAmount = attrs.pageAmount || 9;

			var __getPages = function() {
				if (!scope.pagination || !scope.pagination.currentPage || !scope.pagination.total || !scope.pagination.rowsPerPage) return;
				if (scope.pagination) {
					var maxPage = Math.ceil(scope.pagination.total / scope.pagination.rowsPerPage);
					var currentPage = parseInt(scope.pagination.currentPage, 10);
					scope.pages = [];
					scope.first = scope.last = scope.previous = scope.next = null;

					if (maxPage <= pagesAmount) {
						for (var i=1; i<=maxPage; i++) {
							scope.pages.push(i);
						}
					} else {
						var first, last;

						if (currentPage <= Math.ceil(pagesAmount / 2)) { //very beginning
							first = 1;
							last = pagesAmount;
						} else if (currentPage >= maxPage - Math.floor(pagesAmount / 2)) { //very end
							first = maxPage - pagesAmount + 1;
							last = maxPage;
						} else { //middle
							first = currentPage - Math.floor(pagesAmount / 2);
							first += pagesAmount % 2 === 0 ? 1 : 0;
							last = currentPage + Math.floor(pagesAmount / 2);
						}

						for (var i=first; i <= last; i++) {
							scope.pages.push(i);
						}
					}

					if (currentPage > 1) {
						scope.first = 1;
						scope.previous = currentPage - 1;
					}

					if (currentPage < maxPage) {
						scope.last = maxPage;
						scope.next = currentPage + 1;
					}
				}
			};

			scope.$watch('pagination', function() {
				__getPages();
			});

			scope.jumpToPage = function(page, event) {
				event && event.preventDefault();
				scope.pagination.currentPage = page;
				scope.prevHover = scope.nextHover = false;
				scope.$emit('changeSearchParameters', {from: 'pagination', page: scope.pagination.currentPage, 'paginationObj': scope.pagination});
			};

			scope.$on('recalculatePages', function (e, page) {
				if (!scope.pagination) {
					return;
				}

				scope.pagination.currentPage = page || 1;
				__getPages();
			});
		}
	};
}]);
